import utilitycss from './libs/UtilityCss';
import cssvars from './cssvars';

import PageExperience  from './components/PageExperience';
import WebApplication  from './components/WebApplication';

console.log("MICROSOFT VDC v4.8");

if (document.querySelector('.dg.main.a')) {
    document.querySelector('.dg.main.a').addEventListener('mousemove', function(e) {
        e.stopPropagation()
        e.preventDefault()
    })
}
